import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';
import { css } from '@emotion/core';
import { rem } from 'polished';
import { themeGet } from 'styled-system';
import { Box, Flex, Link, NakedButton, Hide, Heading } from '@qga/roo-ui/components';
import { mediaQuery } from 'lib/styledSystem';

type RoomDescriptionProps = {
  isExclusive?: boolean;
};

export const ExclusiveHeading = styled(Heading.h4)`
  width: 80%;
  display: block;
  font-weight: normal;
  font-size: ${themeGet('fontSizes.md')};
  line-height: normal;

  ${mediaQuery.minWidth.sm} {
    pointer-events: none;
  }
`;

export const ParagraphWrapper = styled(Flex)<RoomDescriptionProps>`
  padding-top: ${themeGet('space.4')};
  flex-direction: column;
  border-top: ${themeGet('borders.1')} ${themeGet('colors.greys.alto')};

  ${mediaQuery.minWidth.sm} {
    padding-top: ${themeGet('space.0')};
    border-top: none;
  }
`;

export const CollapseWrapper = styled(Hide)`
  flex-grow: 1;
  text-align: right;
  justify-self: flex-end;
`;

export const FullWidthButton = styled(NakedButton)`
  width: 100%;
  text-align: center;
`;

export const CollapsedBox = styled(ParagraphWrapper)<RoomDescriptionProps>`
  width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  height: ${(props) => (props.isExclusive ? rem('180px') : rem('76px'))};

  ${mediaQuery.minWidth.sm} {
    height: ${(props) => (props.isExclusive ? rem('175px') : rem('76px'))};
  }
`;

export const RoomContainer = styled(Box)`
  flex-grow: 1;
  width: 100%;
  margin-bottom: 0;
  padding-bottom: ${themeGet('space.4')};

  ${mediaQuery.minWidth.sm} {
    margin-bottom: ${(props) => (props.exclusiveOffer ? themeGet('space.10') : themeGet('space.4'))};
    border-bottom: 0;
    padding-bottom: 0;
    padding-left: ${(props) => (props.exclusiveOffer ? '40px' : 0)};
    padding-right: ${(props) => (props.exclusiveOffer ? '40px' : 0)};
  }

  ${mediaQuery.minWidth.md} {
    flex-direction: row;
    margin-left: ${(props) => (props.exclusiveOffer ? '30px' : 0)};
    flex: 1;
    padding-left: 0;
    padding-right: 0;
    margin-bottom: ${(props) => (props.exclusiveOffer ? 0 : themeGet('space.4'))};
  }
`;

export const OfferWrapper = styled(Flex)`
  position: relative;
  background: ${themeGet('colors.white')};
  flex-direction: column;

  ${mediaQuery.minWidth.sm} {
    flex-direction: row;
    border-radius: ${themeGet('radii.default')};
    border: ${themeGet('borders.1')} ${themeGet('colors.greys.alto')};
  }
`;

export const RetrySearchLink = styled(Link)`
  text-decoration: underline;
  font-size: ${themeGet('fontSizes.sm')};
  color: ${themeGet('colors.greys.steel')};
`;

interface ExtraFlexProps {
  expanded: boolean;
}

export const ExtraFlex = styled(Flex, { shouldForwardProp: isPropValid })<ExtraFlexProps>`
  position: relative;
  flex-direction: column;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    height: ${(props) => (props.expanded ? '0' : '3em')};
    background: ${themeGet('colors.gradients.transparentToWhite')};
  }
`;

type TitleWrapperProps = {
  showBottomBorder: boolean;
};

export const TitleWrapper = styled(Box, { shouldForwardProp: isPropValid })<TitleWrapperProps>`
  display: flex;
  flex: 1 1 0px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${themeGet('space.4')}};
  padding-bottom: ${themeGet('space.2')}};
  
  ${(props) =>
    props.showBottomBorder &&
    css`
      border-bottom: ${themeGet('borders.1')(props)} ${themeGet('colors.greys.alto')(props)};
    `}
`;

export const MobileButton = styled(NakedButton)`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  ${mediaQuery.minWidth.sm} {
    display: none;
  }
`;
